export default "__VITE_ASSET__BWoycd6r__"